package one.healthium.payments.models

data class PurchaseOptions(
    val product: ProductDetails,
)